<template>
  <div>
    <v-container>
      <v-card>
        <v-card-text>
          <v-toolbar color="primary" light>
            <v-toolbar-title class="white--text">
              Slides
            </v-toolbar-title>
          </v-toolbar>
        </v-card-text>
      </v-card>
    </v-container>
    <v-container>
      <v-layout row>
        <v-flex v-for="(slide, i) in slides" :key="i" xs4>
          <v-img
            :src="slide.image"
            aspect-ratio="2"
            @contextmenu.stop="show($event, slide)"
          />
        </v-flex>
        <v-flex v-if="vid" xs4 style="position:relative;">
          <v-img
            :src="image == '' ? 'img/addimg.png' : image"
            aspect-ratio="2"
            contain
            @click="selectFile"
          />
          <v-flex
            v-if="uploading"
            d-flex
            align-center
            align-content-center
            style="position:absolute;left:0;top:0;width:100%;height:100%;background:rgba(0,0,0,0.5);"
          >
            <v-progress-circular
              :value="progress"
              color="primary lighten-2"
              size="75"
            />
          </v-flex>
        </v-flex>
      </v-layout>
      <input
        ref="fileinput"
        type="file"
        style="display:none;"
        @change="pickFile($event)"
      />
      <v-menu
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
      >
        <v-list>
          <v-list-tile @click="deleteSlide">
            <v-list-tile-title>delete slide</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <div class="text-xs-center" style="width:100%;">
        <strong>Note:</strong>right click to delete slide
      </div>
    </v-container>
  </div>
</template>
<script type="text/javascript">
import axios from '@/api'
export default {
  data() {
    return {
      file: '',
      image: '',
      progress: 0,
      uploading: false,
      slide: {},
      slides: [],
      x: 0,
      y: 0,
      showMenu: false
    }
  },
  computed: {
    vid() {
      return this.$store.state.vid
    }
  },
  watch: {
    vid() {
      this.reload()
    }
  },
  created() {
    if (this.$store.state.vid) {
      axios
        .get('sliders')
        .then(r => {
          this.slides = r.data
        })
        .catch(async err => {
          if (err.message === 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true }
              ]
            })
            if (res) {
              this.reload()
            }
          }
        })
    }
  },
  methods: {
    selectFile() {
      this.$refs.fileinput.click()
    },
    reload() {
      let loader = this.$loading.show()
      axios
        .get('sliders')
        .then(r => {
          this.slides = r.data
          loader.hide()
        })
        .catch(async err => {
          loader.hide()
          if (err.message === 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true }
              ]
            })
            if (res) {
              this.reload()
            }
          }
        })
    },
    save() {
      let loader = this.$loading.show()
      axios
        .post('sliders', this.file_name)
        .then(r => {
          this.slides.push(r.data.slide)
          loader.hide()
        })
        .catch(async err => {
          loader.hide()
          if (err.message === 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true }
              ]
            })
            if (res) {
              this.save()
            }
          }
        })
    },
    deleteSlide() {
      var id = this.slide.id
      let loader = this.$loading.show()
      axios
        .delete('sliders/' + id)
        .then(r => {
          this.slides.splice(
            this.slides.findIndex(s => s.id === id),
            1
          )
          loader.hide()
        })
        .catch(async err => {
          loader.hide()
          if (err.message === 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true }
              ]
            })
            if (res) {
              this.deleteSlide()
            }
          }
        })
    },
    show(e, slide) {
      e.preventDefault()

      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
      this.slide = slide
    },

    pickFile(e) {
      if (e.target.files.length > 0) {
        this.file = e.target.files[0]
        this.image = URL.createObjectURL(this.file)

        this.uploadImage(this.file)
      }
    },
    uploadImage(file) {
      this.uploading = true
      let formData = new FormData()
      formData.append('image', file)
      axios
        .post('upload/file', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: progressEvent =>
            (this.progress = progressEvent.total)
        })
        .then(r => {
          this.image = r.data.file_url
          axios.post('sliders', { image: this.image, caption: '' }).then(r => {
            this.slides.push(r.data)
            this.uploading = false
            this.image = ''
            this.file = ''
          })
        })
        .catch(err => {
          console.log(err)
          this.dialog2 = true
        })
    }
  }
}
</script>
